import { UsersIcon } from 'app/agriculture/icons';
import { TasksListGroup } from 'app/agriculture/routes/Tasks/TaskList/components/TasksListGroup/TasksListGroup';
import { useCurrentUser } from 'app/agriculture/hooks/users/useCurrentUser';
import { useUsers } from 'app/agriculture/hooks/users/useUsers';
import { Task } from 'app/agriculture/queries/tasks/types/Task';

interface AllTasksUserViewProps {
    tasks: Task[];
}

export function TaskListUserView({ tasks }: AllTasksUserViewProps) {
    const currentUser = useCurrentUser();
    const users = useUsers().sort(({ id }) => (id === currentUser.id ? -1 : 1));

    if (tasks.length === 0) {
        return null;
    }

    return (
        <>
            {users.map((user) => {
                const isCurrentUser = user.id === currentUser.id;
                const title = isCurrentUser ? 'My Tasks' : `${user.name}'s Tasks`;
                const thisUsersTasks = tasks.filter(({ assignees }) =>
                    assignees.some((assignee) => assignee === user.id),
                );

                if (thisUsersTasks.length === 0) {
                    return null;
                }

                return (
                    <TasksListGroup
                        key={user.id}
                        title={title}
                        icon={<UsersIcon size={18} />}
                        tasks={thisUsersTasks}
                        startExpanded={isCurrentUser}
                    />
                );
            })}
        </>
    );
}
